import moment from 'moment-timezone';
import { TOKEN_EXPIRED } from '../constants';
// Function to get jwt payloads from token
export const jwtPayloads = (token) => {
	let tokenSplits = token.split('.');
	if (tokenSplits)
		return tokenSplits[1];
	return false
}

// Function to decode jwt payloads
export const jwtDecode = (payloads) => {
	if (payloads)
		return window.atob(payloads);
	return false
}

// Function to check authorization in error response
export const checkAuthorized = ({ error }) => {
	return error.status_code !== TOKEN_EXPIRED.status_code;
}

// Function to manipulate error adjust with API schemes
class InvalidRoleException {
	constructor(message, status_code = 401) {
		this.message = message;
		this.status_code = status_code;
	}
}
export { InvalidRoleException };

export const manipulateErrors = (err) => {
	return (err.response !== null && err.response !== undefined) ? { ...err.response.data } :
		(err instanceof InvalidRoleException ? { error: { message: err.message, status_code: err.status_code } } : { error: { message: 'I got something undefined errors', status_code: 500 } });
}

/**
 * JavaScript Code Snippet
 * Convert Number to Rupiah & vice versa
 * https://gist.github.com/845309
 *
 * Copyright 2011-2012, Faisalman
 * Licensed under The MIT License
 * http://www.opensource.org/licenses/mit-license  
 *
 */

export const convertToRupiah = (angka) => {
	var rupiah = '';
	var angkarev = angka.toString().split('').reverse().join('');
	for (var i = 0; i < angkarev.length; i++) if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + '.';
	return rupiah.split('', rupiah.length - 1).reverse().join('');
}
/**
 * Usage example:
 * alert(convertToRupiah(10000000)); -> "Rp. 10.000.000"
 */

export const convertToAngka = (rupiah) => {
	return parseInt(rupiah.replace(/,.*|[^0-9]/g, ''), 10);
}
/**
 * Usage example:
 * alert(convertToAngka("Rp 10.000.123")); -> 10000123
 */

export const generateNumber = (perPage, currentPage, indexLoop) => parseInt((perPage * (currentPage - 1)) + indexLoop + 1)


export const shippingRate = (category) => {
	const settings = {
		sneakers: [40000, 80000, 120000],
		apparels: [20000, 40000, 80000],
		handbags: [40000, 80000, 120000]
	}
	return settings[category] ? settings[category] : settings.sneakers
}

export const formatDailyStartTime = (time) => {
	if (!time) {
		return '';
	}
	const result = moment(time, 'HH:mm:ss').format('HH:mm');
	if (result === 'Invalid date') {
		return time;
	}
	return result;
}